import { Center } from '@mantine/core';
import { Text } from 'components/text/Text';
import { FC, ReactNode } from 'react';

interface TablePlaceholder {
    placeholder: ReactNode;
}

export const TablePlaceholder: FC<TablePlaceholder> = ({ placeholder }) => {
    return (
        <Center w={'100%'}>
            {typeof placeholder === 'string' ? (
                <Text size="sm" c="gray.6" my="sm">
                    {placeholder}
                </Text>
            ) : (
                placeholder
            )}
        </Center>
    );
};
